
export const getSafeModeHeaders = (featureKeys) => {
    const isSafeModeFeatureEnabled = featureKeys && featureKeys["NetApp.TenancyV4/safemode"]?.active;
    return isSafeModeFeatureEnabled ? {
                headers: {
                    'Accept': 'application/vnd.netapp.bxp.user.safemode+json'
                }
        } : {};
}